import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup, Label, Form } from "reactstrap";
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { FaTrashAlt } from 'react-icons/fa';
import { GetWorkorderTechnician } from '../../../../../action/workorderAction';
import ReportPeriod from '../ReportPeriod';

class TechnicianReportFilter extends Component {

    componentWillMount() {
        this.props.GetWorkorderTechnician();

        if(this.props.IsEdit){
            var lFilters = this.props.SavedData, selectedAssignedToId = [], selectedAssignedTo = [];
            if(lFilters.AssignedTo !== null){
                if(this.props.getTechnicianList !== undefined && this.props.getTechnicianList !== null && this.props.getTechnicianList.length){
                    lFilters.AssignedTo.forEach(el => {
                        var data2 = this.props.getTechnicianList.filter(e => e.technicianID === el.assignedUserID)[0];
                        selectedAssignedTo.push({"id" : el.assignedUserID, "value" : data2.name});
                        selectedAssignedToId.push(el.assignedUserID);
                    })
                }
            }
            this.setState({
                SelectedAssignedTo : selectedAssignedToId,
                SelectedAssignedToList : selectedAssignedTo
            }) 
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            SelectedAssignedToList: [],
            SelectedAssignedTo: []
        }
        
        this.DeleteAssignedTo = this.DeleteAssignedTo.bind(this);
        this.dropdown_fields = { text: 'value', value: 'id' };
    }

    onAssignedToSelect(args) { 
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        l_SelectedAssignedTo.push(args.itemData);
        this.setState({ SelectedAssignedToList : l_SelectedAssignedTo });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":l_SelectedAssignedTo});
    }

    onAssignedToRemove(args){
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        var FilteredData = l_SelectedAssignedTo.filter(x => x.id !== args.itemData.id);
        this.setState({ SelectedAssignedToList : FilteredData });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":FilteredData});
    }

    DeleteAssignedTo(AssignedToId){ 
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        var FilteredData = l_SelectedAssignedTo.filter(x => x.id !== AssignedToId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedAssignedToId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : FilteredData, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":FilteredData});
    }

    render() {
        //let label = this.props.getLabels;
        let preferredfields = this.props.getWorkorderPreferences;
        var Assigned_in_Select_input = [] ;
        var AssignedToList = [];

        var assignedto = (preferredfields !== "" && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : "";
        
        //AssignedTo
        if (this.props.getTechnicianList !== undefined && this.props.getTechnicianList !== null && this.props.getTechnicianList.length) {
            this.props.getTechnicianList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase())).forEach(el => {
                Assigned_in_Select_input.push({ "id" : el.technicianID, "value" : el.name });
            });
        }
        if (this.state.SelectedAssignedToList !== undefined && this.state.SelectedAssignedToList !== null && this.state.SelectedAssignedToList.length) {
            var lstData4 = this.state.SelectedAssignedToList;
            const rows = [...Array( Math.ceil(lstData4.length / 3) )];
            // chunk the products into the array of rows
            const productRows = rows.map( (row, idx) => lstData4.slice(idx * 3, idx * 3 + 3) );
            // map the rows as div.row
            AssignedToList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  {/* map products in the row as article.col-md-3 */}
                  { row.map( product => <div key={product.id} className="col-md-2">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteAssignedTo(product.id) }} /></div>
                  </div> )}
                </div> 
            ));
        }

        return (
            <div>
                <Form className="form-visible">
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <Label id="label_filters" className="reportsHeaderlbl">Filters</Label>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <ReportPeriod IsEdit={this.props.IsEdit} isUnChecked={this.props.isUnChecked} FilterSelection={this.props.FilterSelection} reportSetting={this.props.reportSetting} dateValidation={this.props.dateValidation} dataValue={this.props.dataValue} />
                        </Col> 
                    </FormGroup>

                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_assignedto" style={{ marginBottom: "0px" }} className="workorderlbl">{assignedto.length > 0 ? assignedto[0].fieldLabel : "Assigned To"}</Label><br />
                            <MultiSelectComponent id="select_assignedto" ref='assigned_in_Select_input' width='100%' cssClass="WO_Filter_Multi_Ddl"
                                dataSource={Assigned_in_Select_input}
                                select={this.onAssignedToSelect.bind(this)}
                                removed={this.onAssignedToRemove.bind(this)}
                                fields={this.dropdown_fields}
                                value={this.state.SelectedAssignedTo}
                                mode="CheckBox"
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false}
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </Col>
                    </FormGroup>              
                    <FormGroup row style={{marginBottom: "20px"}}>
                        <Col sm={{ size: 12 }}>
                            {AssignedToList}
                        </Col>
                    </FormGroup>

                </Form>
            </div>
        )
    };
};

const mapStateToProps = (state) => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getReportDetails: state.WorkorderRootReducer.WorkorderReportsDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianReportFilter);